import { ApiSuccessResponse } from 'network/config/interface';
import { DELETE_INBOX, GET_INBOX_MESSAGES, MARK_INBOX_AS_READ } from '../config/endpoints';
import api from '../config/setAuthHeader';

export const getInboxMessages = async () => {
  return await api.get(GET_INBOX_MESSAGES);
};

export const markInboxAsRead = async (id: number): Promise<ApiSuccessResponse<any>> => {
  return api.post(`${MARK_INBOX_AS_READ}/${id}/read`);
};

export const markAllInboxesAsRead = async (): Promise<ApiSuccessResponse<any>> => {
  return api.post(`${MARK_INBOX_AS_READ}/read-all`);
};

export const deleteInbox = async (id: number): Promise<ApiSuccessResponse<any>> => {
  return api.delete(`${DELETE_INBOX}/${id}/delete`);
};
